import RequestToken from '../../../../tokens/RequestToken';
import {CommandRequester} from '../../../../CommandRequester';
import RequestAPI from '../../../RequestAPI';
import {Event} from '../../../../events/Event';
import {AsyncCommandEvent, ScreenGestureEvents, CommandTypes, StreamTypes} from '@jibo/command-protocol';


/**
 * @class ScreenGestureToken
 * @extends RequestToken
 * @hideconstructor
 */
export class ScreenGestureToken extends RequestToken<JIBO.v1.ScreenGestureRequest> {
    /**
     * Tap screen gesture. Event is `{x: number, y: number}` of tap location.
     * @name ScreenGestureToken#tap
     * @type {Event<CommandRequester.Vector2>}
     */
    public tap:Event<JIBO.v1.Vector2>;

    /**
     * Swipe screen gesture. Type is direction of swipe.
     * @name ScreenGestureToken#swipe
     * @type {Event<SwipeDirection>}
     */
    public swipe:Event<JIBO.v1.SwipeDirections.SwipeDirectionType>;


    /** @private */
    constructor(owner: CommandRequester, protocol: JIBO.v1.ScreenGestureRequest) {
        super(owner, protocol);
        this.tap = new Event(ScreenGestureEvents.Tap);
        this.swipe = new Event(ScreenGestureEvents.Swipe);
    }

    /**
     * @private
     */
    public handleAck(ack:JIBO.v1.Acknowledgement) {
        //handle ack
        if (ack.Response.ResponseCode >= 400) {
            this.isComplete = true;
            this._complete.reject(ack.Response);
            return;
        }
    }

    /**
     * @private
     */
    public handleEvent(event:JIBO.v1.EventMessage) {
        //handle event
        const eventData = event.EventBody;
        switch (eventData.Event) {
            case AsyncCommandEvent.Stop:
                this.isComplete = true;
                this._complete.resolve();
                break;
            case AsyncCommandEvent.Error:
                this.isComplete = true;
                this._complete.reject(eventData);
                break;
            case ScreenGestureEvents.Tap:
                 this.tap.emit(eventData.Coordinate);
                 break;
            case ScreenGestureEvents.Swipe:
                 this.swipe.emit(eventData.Direction);
                 break;

        }
    }
}

/**
 * Internal Gesture class
 * @class CommandRequester.display.subscribe.Gesture
 * @intdocs
 */
export class Gesture extends RequestAPI<JIBO.v1.ScreenGestureRequest, ScreenGestureToken> {
    public owner;

    constructor(requester:CommandRequester) {
        super(requester);
    }

    /**
     * Generate Screen Gesture Protocol
     * @method CommandRequester.display.subscribe.Gesture#generateProtocol
     * @param {CommandRequester.display.ScreenGestureFilter} [filter={}]
     * @returns {ScreenGestureRequest}
     * @intdocs
     */
    static generateProtocol(filter: JIBO.v1.ScreenGestureFilter = {}): JIBO.v1.ScreenGestureRequest {
        return {
            Type: CommandTypes.Subscribe,
            StreamType: StreamTypes.ScreenGesture,
            StreamFilter: filter
        };
    }

    /**
     * Create ScreenGestureToken from ScreenGestureRequest protocol.
     * @method CommandRequester.display.subscribe.Gesture#generateToken
     * @param {ScreenGestureRequest} protocol - ScreenGestureRequest protocol to generate a ScreenGestureToken from.
     * @param {boolean} [andSend=false] - `true` if the generated ScreenGestureToken should also be sent as a request.
     * @return {ScreenGestureToken}
     * @intdocs
     */
    public generateToken(protocol: JIBO.v1.ScreenGestureRequest, andSend=false): ScreenGestureToken {
        const token = new ScreenGestureToken(this.owner, protocol);
        if (andSend) {
            super.sendToken(token);
        }
        return token;
    }


}